const MONTH_NAMES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

// The month filter only lets the user pick a month name, never a year, and
// only offers the months still ahead this year (including the current one) —
// courses filtered here are always current/future, so anything earlier can't apply.
export function monthOptions(): { label: string; value: string }[] {
  const currentMonth = new Date().getMonth() + 1;
  return [
    { label: "Todos", value: "" },
    ...MONTH_NAMES.slice(currentMonth - 1).map((name, i) => ({
      label: name,
      value: String(currentMonth + i).padStart(2, "0"),
    })),
  ];
}

export function monthNumber(filterValue: string): string {
  return filterValue.includes("-") ? filterValue.split("-")[1] : filterValue;
}

export function monthFilterValue(month: string): string {
  return month ? `${new Date().getFullYear()}-${month}` : "";
}
